<div class="container-fluid px-0">
 <!-- <div class="col banner-negro">
   
     <div *ngIf="!isFinished" class="timer-display">
       <span  class="time-unit-2">¡Preparate para nuestra Venta Flash!</span>
    <div class="time-unit">
      <span class="number">{{ days | number:'2.0' }}</span>
      <span class="label">Días</span>
    </div>
    
    <div class="time-unit">
      <span class="number">{{ hours | number:'2.0' }}</span>
      <span class="label">Horas</span>
    </div>
    
    <div class="time-unit">
      <span class="number">{{ minutes | number:'2.0' }}</span>
      <span class="label">Minutos</span>
    </div>

    <div class="time-unit">
      <span class="number">{{ seconds | number:'2.0' }}</span>
      <span class="label">Segundos</span>
    </div>
  </div>

  <p *ngIf="isFinished" class="finished-message">¡El evento ha comenzado!</p>
    
  </div>-->
  <div id="carouselExample" class="carousel slide" data-bs-ride="false">
    <div class="carousel-indicators">
      <button *ngFor="let ban of arrayBannerEcommerce; let i = index" type="button" data-bs-target="#carouselExample"
        [attr.data-bs-slide-to]="i" [ngClass]="{'active': i === 0}" [attr.aria-current]="i === 0 ? 'true' : null"
        [attr.aria-label]="'Slide ' + (i + 1)">
      </button>
      <!-- <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1" ></button>
      <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="1" aria-label="Slide 2" *ngIf="imagenCargada2"></button>
      <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="2" aria-label="Slide 3"*ngIf="imagenCargada3"></button>
      <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="3" aria-label="Slide 4"*ngIf="imagenCargada4"></button>
      <button type="button" data-bs-target="#carouselExample" data-bs-slide-to="4" aria-label="Slide 5" *ngIf="imagenCargada5"></button> -->
    </div>
    <div class="carousel-inner hero-frame">
      <div class="carousel-item" data-bs-interval="7000" [ngClass]="{ 'active': ind === 0 }"
        *ngFor="let ban of arrayBannerEcommerce; let ind = index;let first = first">
        <!-- Interno: /especiales/ofertas-quimicos?id=1 -->
        <a *ngIf="isInternal(ban.strCorreo); else externalLink" [routerLink]="getPath(ban.strCorreo)"
          [queryParams]="getQuery(ban.strCorreo)"  rel="noopener noreferrer" target="_blank"><!--target="_blank" -->
          <img [src]="ban.strUrl" width="1366" height="356" class="d-block w-100 hero-img"
            [attr.fetchpriority]="first ? 'high' : null" [attr.decoding]="first ? 'sync' : 'async'"
            [attr.sizes]="'100vw'" [attr.srcset]="ban.srcset || null" alt="" (load)="first && onHeroLoaded()"
            fetchpriority="high">
        </a>
        <!-- class="d-block w-100" fetchpriority="high"
          decoding="async" -->
        <!-- Externo: www.ecodeli.com/tienda/... o https://... -->
        <ng-template #externalLink>
          <a [href]="normalizeExternal(ban.strCorreo)" rel="noopener noreferrer" target="_blank"> <!-- -->
            <img [src]="ban.strUrl" width="1366" height="356" class="d-block w-100 hero-img"
              [attr.loading]="first ? 'eager' : 'lazy'" [attr.fetchpriority]="first ? 'high' : null"
              [attr.decoding]="first ? 'sync' : 'async'" [attr.sizes]="'100vw'" [attr.srcset]="ban.srcset || null"
              alt="" (load)="first && onHeroLoaded()"
              fetchpriority="high"><!--   class="d-block w-100" decoding="async"  -->
          </a>
        </ng-template>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</div>
<div class="container pb-0">
  <div class="row  justify-content-between">
    <div class="col-12 col-md-6 mt-2 d-flex"
      [ngClass]="{'col-lg-4 ':cartItems.length>0,'col-lg-8':cartItems.length==0}">
      <div class="col-12 bg-white shadow-sm pb-2 px-2 d-flex flex-column">
        <label for="" class="col-11 titCards fs-6 fw-bold nunito text-start pt-2 ">
          ARTÍCULOS DESTACADOS
        </label>
        <div id="carDestacados" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active" *ngIf="arrayNovedades.length>0 ">
              <div class="row" *ngIf="cartItems.length>0">
                <div class="col-6 d-flex flex-column pointer" (click)="addToCart(arrayNovedades[0])">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{arrayNovedades[0]?.strArticulo}}.webp"
                    class="d-block w-100" alt="Producto 1">
                  <div class="d-flex flex-column h-100">
                    <h5 class="descripcion-truncada">{{arrayNovedades[0]?.strDescripcion}}</h5>
                    <p class="fw-bold fs14 nunito align-items-center d-flex justify-content-between px-2">
                      <i class="bi bi-cart4 fs-5"></i>
                      <span class="d-flex flex-column">
                        <span class="precio mb-0 text-start"
                          [ngClass]="{'fs11 text-decoration-line-through text-dark':arrayNovedades[0].dblPrecioOferta>0,'fw-bolder fs-6 text-dark':arrayNovedades[0].dblPrecioOferta==0}">{{
                          arrayNovedades[0]?.dblPrecioLista|currency}}</span>
                        <span class="precio fw-bolder mb-0 text-start fs-6 text-dark"
                          *ngIf="arrayNovedades[0].dblPrecioOferta>0">{{
                          arrayNovedades[0]?.dblPrecioOferta|currency}}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="col-6 d-flex flex-column pointer" *ngIf="arrayNovedades.length>1"
                  (click)="addToCart(arrayNovedades[1])">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{arrayNovedades[1]?.strArticulo}}.webp"
                    class="d-block w-100" alt="Producto 2">
                  <h5 class="descripcion-truncada">{{arrayNovedades[1]?.strDescripcion}}</h5>
                  <p class="fw-bold fs14 nunito align-items-center d-flex justify-content-between px-2">
                    <i class="bi bi-cart4 fs-5"></i>
                    <span class="d-flex flex-column">
                      <span class="precio mb-0 text-start"
                        [ngClass]="{'fs11 text-decoration-line-through text-dark':arrayNovedades[1].dblPrecioOferta>0,'fw-bolder fs-6 text-dark':arrayNovedades[1].dblPrecioOferta==0}">{{
                        arrayNovedades[1]?.dblPrecioLista|currency}}</span>
                      <span class="precio fw-bolder mb-0 text-start fs-6 text-dark"
                        *ngIf="arrayNovedades[1].dblPrecioOferta>0">{{
                        arrayNovedades[1]?.dblPrecioOferta|currency}}</span>
                    </span>
                  </p>
                </div>
              </div>
              <div class="row" *ngIf="cartItems.length==0">
                <div class="col-3 d-flex flex-column pointer" (click)="addToCart(arrayNovedades[0])">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{arrayNovedades[0]?.strArticulo}}.webp"
                    class="d-block w-100" alt="Producto 1">
                  <div class="d-flex flex-column h-100">
                    <h5 class="descripcion-truncada">{{arrayNovedades[0]?.strDescripcion}}</h5>
                    <p class="fw-bold fs14 nunito align-items-center d-flex justify-content-between px-2 mt-auto">
                      <i class="bi bi-cart4 fs-5"></i>
                      <span class="d-flex flex-column">
                        <span class="precio mb-0 text-start"
                          [ngClass]="{'fs11 text-decoration-line-through text-dark':arrayNovedades[0].dblPrecioOferta>0,'fw-bolder fs-6 text-dark':arrayNovedades[0].dblPrecioOferta==0}">{{
                          arrayNovedades[0]?.dblPrecioLista|currency}}</span>
                        <span class="precio fw-bolder mb-0 text-start fs-6 text-dark"
                          *ngIf="arrayNovedades[0].dblPrecioOferta>0">{{
                          arrayNovedades[0]?.dblPrecioOferta|currency}}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column pointer" (click)="addToCart(arrayNovedades[1])">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{arrayNovedades[1]?.strArticulo}}.webp"
                    class="d-block w-100" alt="Producto 2">
                  <div class="d-flex flex-column h-100">
                    <h5 class="descripcion-truncada">{{arrayNovedades[1]?.strDescripcion}}</h5>
                    <p class="fw-bold fs14 nunito align-items-center d-flex justify-content-between px-2 mt-auto">
                      <i class="bi bi-cart4 fs-5"></i>
                      <span class="d-flex flex-column">
                        <span class="precio mb-0 text-start"
                          [ngClass]="{'fs11 text-decoration-line-through text-dark':arrayNovedades[1].dblPrecioOferta>0,'fw-bolder fs-6 text-dark':arrayNovedades[1].dblPrecioOferta==0}">{{
                          arrayNovedades[1]?.dblPrecioLista|currency}}</span>
                        <span class="precio fw-bolder mb-0 text-start fs-6 text-dark"
                          *ngIf="arrayNovedades[1].dblPrecioOferta>0">{{
                          arrayNovedades[1]?.dblPrecioOferta|currency}}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column pointer" *ngIf="arrayNovedades.length>2"
                  (click)="addToCart(arrayNovedades[2])">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{arrayNovedades[2]?.strArticulo}}.webp"
                    class="d-block w-100" alt="Producto 1">
                  <div class="d-flex flex-column h-100">
                    <h5 class="descripcion-truncada">{{arrayNovedades[2]?.strDescripcion}}</h5>
                    <p class="fw-bold fs14 nunito align-items-center d-flex justify-content-between px-2 mt-auto">
                      <i class="bi bi-cart4 fs-5"></i>
                      <span class="d-flex flex-column">
                        <span class="precio mb-0 text-start"
                          [ngClass]="{'fs11 text-decoration-line-through text-dark':arrayNovedades[2].dblPrecioOferta>0,'fw-bolder fs-6 text-dark':arrayNovedades[2].dblPrecioOferta==0}">{{
                          arrayNovedades[2]?.dblPrecioLista|currency}}</span>
                        <span class="precio fw-bolder mb-0 text-start fs-6 text-dark"
                          *ngIf="arrayNovedades[2].dblPrecioOferta>0">{{
                          arrayNovedades[2]?.dblPrecioOferta|currency}}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column pointer position-relative" *ngIf="arrayNovedades.length>3"
                  (click)="addToCart(arrayNovedades[3])">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{arrayNovedades[3]?.strArticulo}}.webp"
                    class="d-block w-100" alt="Producto 2">
                  <div class="d-flex flex-column h-100">
                    <h5 class="descripcion-truncada">{{arrayNovedades[3]?.strDescripcion}}</h5>
                    <p class="fw-bold fs14 nunito align-items-center d-flex justify-content-between px-2 mt-auto">
                      <i class="bi bi-cart4 fs-5 "></i>
                      <span class="d-flex flex-column">
                        <span class="precio mb-0 text-start"
                          [ngClass]="{'fs11 text-decoration-line-through text-dark':arrayNovedades[3].dblPrecioOferta>0,'fw-bolder fs-6 text-dark':arrayNovedades[3].dblPrecioOferta==0}">{{
                          arrayNovedades[3]?.dblPrecioLista|currency}}</span>
                        <span class="precio fw-bolder mb-0 text-start fs-6 text-dark"
                          *ngIf="arrayNovedades[3].dblPrecioOferta>0">{{
                          arrayNovedades[3]?.dblPrecioOferta|currency}}</span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item" *ngIf="arrayNovedades.length>2 && cartItems.length>0">
              <div class="row">
                <div class="col-6 d-flex flex-column pointer position-relative" (click)="addToCart(arrayNovedades[2])">
                  <div class="col-12 ps-0 d-flex position-absolute top-0 start-0">
                    <span class="fw-bold bg-danger text-white d-flex align-items-center py-1 px-2 fs-6 nunito"
                      *ngIf="arrayNovedades[2].dblPrecioOferta>0">
                      {{(100-((arrayNovedades[2].dblPrecioOferta/arrayNovedades[2].dblPrecioLista)*100))|number:'1.0-0'}}
                      %
                    </span>
                    <span class="ms-2 d-flex flex-column bg-danger lh-1 px-2 py-1 text-white"
                      *ngIf="arrayNovedades[2].dblPrecioOferta==0">
                      <span class="fw-bold fs11">PROMOCIÓN</span>
                      <span class="fw-bold fs12">Hot Week</span>
                    </span>
                    <span class="d-flex flex-column lh-1 px-2 py-1 text-danger "
                      *ngIf="arrayNovedades[2].dblPrecioOferta>0">
                      <span class="fw-bold fs11">PROMOCIÓN</span>
                      <span class="fw-bold fs12">Hot Week</span>
                    </span>
                  </div>
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{arrayNovedades[2]?.strArticulo}}.webp"
                    class="d-block w-100" alt="{{arrayNovedades[2]?.strDescripcion}}"
                    title="{{arrayNovedades[2]?.strDescripcion}}">
                  <h5 class="descripcion-truncada">{{arrayNovedades[2]?.strDescripcion}}</h5>
                  <p class="fw-bold fs14 nunito align-items-center d-flex justify-content-between px-2">
                    <i class="bi bi-cart4 fs-5"></i>
                    <span class="d-flex flex-column">
                      <span class="precio mb-0 text-start"
                        [ngClass]="{'fs11 text-decoration-line-through text-dark':arrayNovedades[2].dblPrecioOferta>0,'fw-bolder fs-6 text-dark':arrayNovedades[2].dblPrecioOferta==0}">{{
                        arrayNovedades[2]?.dblPrecioLista|currency}}</span>
                      <span class="precio fw-bolder mb-0 text-start fs-6 text-dark"
                        *ngIf="arrayNovedades[2].dblPrecioOferta>0">{{
                        arrayNovedades[2]?.dblPrecioOferta|currency}}</span>
                    </span>
                  </p>
                </div>
                <div class="col-6 d-flex flex-column pointer position-relative" *ngIf="arrayNovedades.length>3"
                  (click)="addToCart(arrayNovedades[3])">
                  <div class="col-12 ps-0 d-flex position-absolute top-0 start-0">
                    <span class="fw-bold bg-danger text-white d-flex align-items-center py-1 px-2 fs-6 nunito"
                      *ngIf="arrayNovedades[3].dblPrecioOferta>0">
                      {{(100-((arrayNovedades[3].dblPrecioOferta/arrayNovedades[3].dblPrecioLista)*100))|number:'1.0-0'}}
                      %
                    </span>
                    <span class="ms-2 d-flex flex-column bg-danger lh-1 px-2 py-1 text-white"
                      *ngIf="arrayNovedades[3].dblPrecioOferta==0">
                      <span class="fw-bold fs11">PROMOCIÓN</span>
                      <span class="fw-bold fs12">Hot Week</span>
                    </span>
                    <span class="d-flex flex-column lh-1 px-2 py-1 text-danger "
                      *ngIf="arrayNovedades[3].dblPrecioOferta>0">
                      <span class="fw-bold fs11">PROMOCIÓN</span>
                      <span class="fw-bold fs12">Hot Week</span>
                    </span>
                  </div>
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{arrayNovedades[3]?.strArticulo}}.webp"
                    class="d-block w-100" alt="{{arrayNovedades[3]?.strDescripcion}}"
                    title="{{arrayNovedades[3]?.strDescripcion}}">
                  <h5 class="descripcion-truncada">{{arrayNovedades[3]?.strDescripcion}}</h5>
                  <p class="fw-bold fs14 nunito d-flex align-items-center justify-content-between px-2">
                    <i class="bi bi-cart4 fs-5"></i>
                    <span class="d-flex flex-column">
                      <span class="precio mb-0 text-start"
                        [ngClass]="{'fs11 text-decoration-line-through text-dark':arrayNovedades[3].dblPrecioOferta>0,'fw-bolder fs-6 text-dark':arrayNovedades[3].dblPrecioOferta==0}">{{
                        arrayNovedades[3]?.dblPrecioLista|currency}}</span>
                      <span class="precio fw-bolder mb-0 text-start fs-6 text-dark"
                        *ngIf="arrayNovedades[3].dblPrecioOferta>0">{{
                        arrayNovedades[3]?.dblPrecioOferta|currency}}</span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <button *ngIf="arrayNovedades.length>2 && cartItems.length>0" class="carousel-control-prev" type="button"
            data-bs-target="#carDestacados" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Anterior</span>
          </button>
          <button class="carousel-control-next" *ngIf="arrayNovedades.length>2 && cartItems.length>0" type="button"
            data-bs-target="#carDestacados" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Siguiente</span>
          </button>
        </div>
        <div class="col-12 mt-auto" (click)="fnNav('destacados')">
          <span class="text-decoration-underline text-primary">ver más</span>
        </div>
      </div>
    </div>
    <div class="d-none d-lg-block col-lg-4 mt-2 d-flex" *ngIf="cartItems.length>0">
      <div class="col-12 bg-white shadow-sm pb-2 px-2">
        <label for="" class="col-12 fs-6 fw-bold titCards nunito text-start pt-2 d-flex">
          RETOMA TU COMPRA
        </label>
        <div id="carRetomaCompra" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="row">
                <div class="col-6">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{cartItems[0]?.strArticulo}}.webp" class="d-block w-100"
                    alt="Producto 1" (error)="onImageError($event)" loading="lazy">
                  <h5 class="descripcion-truncada">{{cartItems[0]?.strDescripcion}}</h5>
                  <p class="fw-bold fs14 nunito d-flex justify-content-between px-2">
                    <i class="bi bi-cart4 fs-5"></i>
                    <span>{{cartItems[1]?.dblPrecioLista | currency}}</span>
                  </p>
                </div>
                <div class="col-6" *ngIf="cartItems.length>1">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{cartItems[1]?.strArticulo}}.webp" class="d-block w-100"
                    alt="Producto 2" (error)="onImageError($event)" loading="lazy">
                  <h5 class="descripcion-truncada">{{cartItems[1]?.strDescripcion}}</h5>
                  <p class="fw-bold fs14 nunito d-flex justify-content-between px-2">
                    <i class="bi bi-cart4 fs-5"></i>
                    <span>{{cartItems[1]?.dblPrecioLista | currency}}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="carousel-item" *ngIf="cartItems.length>2">
              <div class="row">
                <div class="col-6">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{cartItems[2]?.strArticulo}}.webp" class="d-block w-100"
                    alt="Producto 3" (error)="onImageError($event)" loading="lazy">
                  <h5 class="descripcion-truncada">{{cartItems[2]?.strDescripcion}}</h5>
                  <p class="fw-bold fs14 nunito d-flex justify-content-between px-2">
                    <i class="bi bi-cart4 fs-5"></i>
                    <span>{{cartItems[2]?.dblPrecioLista | currency}}</span>
                  </p>
                </div>
                <div class="col-6" *ngIf="cartItems.length>3">
                  <img width="180" height="180"
                    src="https://dmmunbpfotoc9.cloudfront.net/{{cartItems[3]?.strArticulo}}.webp" class="d-block w-100"
                    alt="Producto 4" (error)="onImageError($event)" loading="lazy">
                  <h5 class="descripcion-truncada">{{cartItems[3]?.strDescripcion}}</h5>
                  <p class="fw-bold fs14 nunito d-flex justify-content-between px-2">
                    <i class="bi bi-cart4 fs-5"></i>
                    <span>{{cartItems[3]?.dblPrecioLista | currency}}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carRetomaCompra" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Anterior</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carRetomaCompra" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Siguiente</span>
          </button>
        </div>
        <!-- <div class="col-12 d-flex justify-content-center">
          <span class="titCards fs11 fw-bold">Sub total:</span> <span class="text-danger fs11 fw-bold">{{subTotalCar|currency}}</span>
        </div> -->
        <div class="col-12" [routerLink]="['/ecommerce','tienda-carrito']">
          <span class="text-decoration-underline text-primary pointer">ver más</span>
        </div>
      </div>
    </div>
    <div class="col-12 py-2 d-md-none">
    </div>
    <div class="col-12 col-md-6 col-lg-4 mt-2 pointer d-flex">
      <div class="col-12 bg-white shadow-sm pb-2 px-2 d-flex flex-column">
        <label for="" class="col-11 titCards fs-6 fw-bold nunito text-start pt-2 ">
          ARTÍCULOS EN LIQUIDACIÓN
        </label>
        <div id="carLiqui" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active" *ngIf="arrayProductosDestacados.length>0">
              <div class="row">
                <div class="col-6 position-relative" (click)="addToCart(arrayProductosDestacados[0])">
                  <div class="ms-2 position-absolute top-0 start-0" *ngIf="arrayProductosDestacados[0].strTipo=='2X1'">
                    <img [src]="'assets/ecommerce/2x1 6220.png'" class="w-50 " alt="">
                  </div>
                  <div class="col-12 px-0 d-flex flex-column">
                    <img width="180" height="180"
                      src="https://dmmunbpfotoc9.cloudfront.net/{{arrayProductosDestacados[0]?.strArticulo}}.webp"
                      class="d-block w-100" alt="Producto 1" (error)="onImageError($event)"
                      alt="{{arrayProductosDestacados[0]?.strDescripcion}}"
                      title="{{arrayProductosDestacados[0]?.strDescripcion}}" loading="lazy">
                    <h5 class="descripcion-truncada mb-auto text-uppercase">
                      {{arrayProductosDestacados[0]?.strDescripcion}}</h5>
                    <div class="col-12 px-0 d-flex">
                      <span
                        class="fw-bold fs11 text-danger me-1">{{arrayProductosDestacados[0]?.intDescuento|number:'1.0-0'}}%</span>
                      <span class="bg-danger px-2 text-white fw-bold fs11 rborder">DESCUENTO</span>
                    </div>
                  </div>
                </div>
                <div class="col-6 position-relative" *ngIf="arrayProductosDestacados.length>1"
                  (click)="addToCart(arrayProductosDestacados[1])">
                  <div class="ms-2 position-absolute top-0 start-0" *ngIf="arrayProductosDestacados[1].strTipo=='2X1'">
                    <img [src]="'assets/ecommerce/2x1 6220.png'" class="w-50 " alt="">
                  </div>
                  <div class="col-12 px-0 d-flex flex-column">
                    <img width="180" height="180"
                      src="https://dmmunbpfotoc9.cloudfront.net/{{arrayProductosDestacados[1]?.strArticulo}}.webp"
                      class="d-block w-100" alt="Producto 2" (error)="onImageError($event)"
                      alt="{{arrayProductosDestacados[1]?.strDescripcion}}"
                      title="{{arrayProductosDestacados[1]?.strDescripcion}}" loading="lazy">
                    <h5 class="descripcion-truncada mb-auto text-uppercase">
                      {{arrayProductosDestacados[1]?.strDescripcion}}</h5>
                    <div class="col-12 px-0 d-flex">
                      <span
                        class="fw-bold fs11 text-danger me-1">{{arrayProductosDestacados[1]?.intDescuento|number:'1.0-0'}}%</span>
                      <span class="bg-danger px-2 text-white fw-bold fs11 rborder">DESCUENTO</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item" *ngIf="arrayProductosDestacados.length>2">
              <div class="row">
                <div class="col-6 position-relative" (click)="addToCart(arrayProductosDestacados[2])">
                  <div class="ms-2 position-absolute top-0 start-0" *ngIf="arrayProductosDestacados[2].strTipo=='2X1'">
                  <img [src]="'assets/ecommerce/2x1 6220.png'" class="w-50 " alt="">
                </div>
                  <div class="col-12 px-0 d-flex flex-column">
                    <img width="180" height="180"
                      src="https://dmmunbpfotoc9.cloudfront.net/{{arrayProductosDestacados[2]?.strArticulo}}.webp"
                      class="d-block w-100" alt="Producto 3" (error)="onImageError($event)"
                      alt="{{arrayProductosDestacados[2]?.strDescripcion}}"
                      title="{{arrayProductosDestacados[2]?.strDescripcion}}" loading="lazy">
                    <h5 class="descripcion-truncada mb-auto text-uppercase">
                      {{arrayProductosDestacados[2]?.strDescripcion}}</h5>
                    <div class="col-12 px-0 d-flex">
                      <span
                        class="fw-bold fs11 text-danger me-1">{{arrayProductosDestacados[2]?.intDescuento|number:'1.0-0'}}%</span>
                      <span class="bg-danger px-2 text-white fw-bold fs11 rborder">DESCUENTO</span>
                    </div>
                  </div>
                </div>
                <div class="col-6 position-relative" *ngIf="arrayProductosDestacados.length>3" (click)="addToCart(arrayProductosDestacados[3])">
                  
                  <div class="ms-2 position-absolute top-0 start-0" *ngIf="arrayProductosDestacados[3].strTipo=='2X1'">
                  <img [src]="'assets/ecommerce/2x1 6220.png'" class="w-50 " alt="">
                
                  </div>
                
                  <div class="col-12 px-0 d-flex flex-column">
                    <img width="180" height="180"
                      src="https://dmmunbpfotoc9.cloudfront.net/{{arrayProductosDestacados[3]?.strArticulo}}.webp"
                      class="d-block w-100" alt="Producto 4" (error)="onImageError($event)"
                      alt="{{arrayProductosDestacados[3]?.strDescripcion}}"
                      title="{{arrayProductosDestacados[3]?.strDescripcion}}" loading="lazy">
                    <h5 class="descripcion-truncada mb-auto text-uppercase">
                      {{arrayProductosDestacados[3]?.strDescripcion}}</h5>
                    <div class="col-12 px-0 d-flex">
                      <span class="fw-bold fs11 text-danger me-1">{{arrayProductosDestacados[3]?.intDescuento|number:'1.0-0'}}%</span>
                      <span class="bg-danger px-2 text-white fw-bold fs11 rborder">DESCUENTO</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carLiqui" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Anterior</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carLiqui" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Siguiente</span>
          </button>
        </div>
        <div class="col-12 mt-auto" (click)="fnNav('liquidacion')">
          <span class="text-decoration-underline text-primary pointer">ver más</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="row  mt-2 pt-2 clsSub justify-content-center">
  <div class="col-12 px-0 position-relative pointer">
    <div id="crouselPartner" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button *ngFor="let ban of arrayBannerPartner; let i = index" type="button" data-bs-target="#crouselPartner"
          [attr.data-bs-slide-to]="i" [ngClass]="{'active': i === 0}" [attr.aria-current]="i === 0 ? 'true' : null"
          [attr.aria-label]="'Slide ' + (i + 1)">
        </button>
      </div>
      <div class="carousel-inner">
        <div class="carousel-item " data-bs-interval="7000" [ngClass]="{'active':ind == 0}" *ngFor="let ban of arrayBannerPartner;let ind = index; let first = first">
          <a [href]="'https://'+ban.strCorreo" target="_blank">
            <img [src]="ban.strUrl" width="1440" height="226" loading="lazy" decoding="async" class="d-block w-100" alt="...">
          </a>
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#crouselPartner" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#crouselPartner" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</div>
</div>


<div class="container">
  <div class="row my-2">
    <div class="col-12">
      <h3 class="text-center w-100 fw-bold fs-4 nunito py-2" for="">
        NUESTRO CATÁLOGO
      </h3>
    </div>
  </div>
  <div class="row mt-0 pt-0">
    <div class="col-12">
      <div class="row justify-content-between">
        <div class=" px-0 d-flex justify-content-center mb-4"
          [ngClass]="{'col5':ind != 0 && ind != 1 && ind != 2&& ind != 3,'col-3':ind == 0 || ind == 1 || ind == 2 ,'col3':ind == 3}"
          (click)="fnIrSubLinea(categoria)" *ngFor="let categoria of arrayCategorias;let ind = index">
          <div class="w95  position-relative shadowSm ">
            <img class="w-100 " [src]="categoria.imagenAlta +'.webp'" alt="{{ categoria.strCategoria }} " width="800"
              height="533" [attr.srcset]="categoria.imagenAlta +'-215.webp 215w ,'  +
            categoria.imagenAlta + '-400.webp 400w,' +
            categoria.imagenAlta +  '-800.webp 800w,' +
            categoria.imagenAlta +'-2667.webp 2667w'
            " [attr.sizes]=" categoria.sizes" loading="lazy">
            <!--[attr.srcset]="categoria.imagen + ' 1x, ' + categoria.imagenAlta + ' 2x'"-->

            <div class="py-3 bg-transparent col-12 position-absolute bottom-0 start-50 translate-middle-x">
              <h3 class="mb-0 cat-title fw-bold text-center">{{ categoria.strCategoria }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row my-3">
    <div class="col-12 text-center">
      <h3 class="mb-0 text-center fw-bold fs-4 my-2">
        NUESTROS METODOS DE PAGO
      </h3>
    </div>
    <div class="col-12 justify-content-center d-flex py-2">
      <div class="row wid95">
        <div class="col-6 col-md-3 d-flex align-items-center justify-content-center">
          <img src="assets/logos/logo-aplazo-color.svg" alt="Aplazo" class="w-50" loading="lazy">
        </div>
        <div class="col-6 col-md-3 d-flex align-items-center justify-content-center">
          <img class="w-50" src="assets/logos/MercadoPago.svg" alt="" loading="lazy">
        </div>
        <div class="col-6 col-md-3 text-center d-flex align-items-center">
          <img class="w-25 mx-auto" [src]="'assets/ecommerce/mastercard.png'" alt="" loading="lazy">
        </div>
        <div class="col-6 col-md-3  d-flex align-items-center justify-content-center">
          <img class="w-50" [src]="'assets/ecommerce/visacard.webp'" alt="" loading="lazy">
        </div>
      </div>

    </div>
  </div>
</div>